module.exports = __webpack_public_path__ + "static/media/noImage.e96eeb6e.png";